/**
 * Created by tofael on 3/27/17.
 */
import React from 'react';
import {connect} from 'react-redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import apiHelper from '../utility/ajax';
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';
import ProgressBar from '../screens/layout/progressbar';
import FeedbackBar from '../screens/layout/feedback-bar';
import Logo from '../screens/shared/logo';

const styles = {
  formTitleBG:{
    backgroundColor:'#E2EDF7'
  },
  formTitle: {
    textAlign: 'center',
    padding:'10px',
    color:'#5f9ea0'
  },
  feedbackMessage: {
    textAlign: 'center',
    color:'#3c7fa0'
  }
};

const initialState = {
  username:'',
  password:'',
  newPassword: '',
  message:''
};

class ResetPassword extends React.Component {

  constructor() {
    super(...arguments);
    this.state = Object.assign({},initialState);
  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  componentDidMount(){
    document.body.style.backgroundColor = "#00bcd4";
  }

  componentWillUnmount(){
    document.body.style.backgroundColor = null;
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.dispatch(asyncStart());
    apiHelper('api/user/password/reset', {method: 'post', body: this.state})
        .then(data => {
          this.setState({username:'',password:'',newPassword:'',message:'Password updated.'});
          this.props.dispatch(asyncEnd());
        })
        .catch(error => {
          this.setState({username:'',password:'',newPassword:'',message:error.message});
          this.props.dispatch(showFeedback({message:error.message}));
          this.props.dispatch(asyncEnd());
        })
  }

  render() {
    const showLoader = this.props.isLoading;
    let loader = null;
    if (showLoader) {
      loader = <ProgressBar/>;
    }
    return (
        <div>
          {loader}
          <Logo/>
          <div className="login-form-wrapper">
            <div style={styles.formTitleBG}><h1 style={styles.formTitle}>Reset Password</h1></div>
            <div style={styles.feedbackMessage}>{this.state.message}</div>
            <form>
              <TextField
                  hintText="email"
                  floatingLabelText="Username"
                  value={this.state.username}
                  autoFocus={true}
                  required={true}
                  className="form-input-wrapper"
                  onChange={this.handleChange.bind(this, 'username')}
              /><br/>
              <TextField
                  hintText=""
                  floatingLabelText="Current Password"
                  value={this.state.password}
                  type="password"
                  required={true}
                  className="form-input-wrapper"
                  onChange={this.handleChange.bind(this, 'password')}
              /><br/>
              <TextField
                  hintText=""
                  floatingLabelText="New Password"
                  value={this.state.newPassword}
                  type="password"
                  required={true}
                  className="form-input-wrapper"
                  onChange={this.handleChange.bind(this, 'newPassword')}
              /><br/>
              <RaisedButton
                  label="Reset"
                  type="button"
                  className="form-input-wrapper login-button"
                  onClick={this.handleSubmit.bind(this)}
                  disabled={this.props.isLoading}
              /><br/>
            </form>
          </div>
          <FeedbackBar/>
        </div>
    );

  }

}

function mapStateToProps(state) {
  return state.application;
}

export default connect(mapStateToProps, null)(ResetPassword);


// WEBPACK FOOTER //
// ./src/containers/reset-password.js